module.exports = __webpack_public_path__ + "static/media/anc3ru.54fe615f.pdf";